<template>
    <div class="authorization">
        <div class="title">高效管理联盟营销平台</div>
        <div class="subtitle">授权连接多个联盟平台，自动化获取数据，生成简单易懂的可视化报告，帮助你高效管理分销项目和决策。</div>

        <div class="aubox">
            <el-row :gutter="8">
                <el-col class="col-item" :span="12" v-for="(item, index) in platformListList" :key="index">
                    <el-card class="box-card">
                        <div class="choosebox">
                            <i v-if="activePlat == item.platformCode" class="el-icon-success"
                                style="width: 18px;height: 18px;font-size: 18px;color: #be3c6e;"></i>
                        </div>
                        <div class="platitem" @click="chooseedPlat(item)">
                            <div class="itemcontent">
                                <div class="img-logo">
                                    <img :src="item.platformLogo" alt="">
                                </div>
                            </div>
                            <div class="item-bottom">
                                <div style="font-size:16px;" class="platname">
                                    {{ item.platformName }}
                                </div>
                                <span v-if="item.list.length" style="font-size:12px;" class="specil" @click.stop="showTips(item)">查看详情</span>
                                <span v-else style="font-size:12px;" class="specil" @click.stop="showTips(item)">授权</span>
                            </div>
                        </div>
                        <div class="lockview"
                            v-if="item.platformCode != 'avantLink' && item.platformCode != 'shareASale' && item.platformCode != 'impact'">
                            <i class="el-icon-lock"></i>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <pc-tips ref="pctips"></pc-tips>
       
    </div>
</template>
<script>
import { AUTH, QUERYPLATFORMLIST } from '@/api/platform'
import pcTips from '@/views/mobile/components/pcTips'
export default {
    components:{
        pcTips
    },
    data() {
        return {
            platformListList: [], // 授权列表
            activePlat: '',
        }
    },
    created() {
        this.queryPlatformListmap()
    },
    mounted() {

    },
    methods: {
        queryPlatformListmap() {
            QUERYPLATFORMLIST().then(res => {
                this.platformListList = res.data.body
                if (this.platformListList.length > 0) {
                    this.activePlat = this.platformListList[0].platformCode
                } else {
                    this.activePlat = ''
                }
            })
        },
        chooseedPlat(info) {
            this.activePlat = info.platformCode
        },
        showTips(info){
            this.chooseedPlat(info)
            this.$refs.pctips.dialogVisible = true
        }

    }
}
</script>
<style lang="less" scoped>
.authorization {
    height: 100%;
    overflow-y: scroll;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px;

    .title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 8px;
    }

    .subtitle {
        font-size: 13px;
        margin-bottom: 15px;
    }

    .aubox {
        .col-item {
            margin-bottom: 8px;
        }

        .box-card {
            position: relative;
            padding-top: 10px;
        }

        .choosebox {
            width: 18px;
            height: 18px;
            background: rgba(166, 168, 191, 0.25);
            position: absolute;
            right: 8px;
            top: 8px;
            border-radius: 50%;
        }

        .lockview {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 10;
            top: 0;
            left: 0;
            line-height: 140px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .platitem {
            height: 90px;
            text-align: center;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;



            .itemcontent {

                .img-logo {
                    img {
                        width: 100%;
                        max-height: 50px;
                    }
                }
            }

            .specil {
                color: #5A8CFF;
            }
        }
    }
}
/deep/.el-dialog{
    border-radius: 8px;
}
/deep/.el-dialog__body{
    padding: 8px 20px;
}
</style>